import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MenuNaviService } from './utils/menu-navi.service';
import { TraductionService } from './utils/traduction.service';
import { LoggerService } from './utils/logger.service';
import { UserService } from './classes/User/user.service';
import { WebsocketService } from './utils/websocket.service';
import { ModulesManagerService } from './classes/Module/modules-manager.service';
import { ToolsService } from './utils/tools.service';
import { ScanQr } from './classes/ScanQr/scan-qr';
import { RouteReuseStrategy } from '@angular/router';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { DocumentsService } from './utils/documents.service';
import { FormBuilder } from '@angular/forms';
import { LoaderModule } from './components/loader/loader.module';
import { SQLiteService } from './services/sqlite.service';
import { CameraViewerService } from './Modales/CameraViewer/camera-viewer.service';

//import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';

@NgModule({
  declarations: [AppComponent],
  //imports: [BrowserModule, IonicModule.forRoot({animated: false}), AppRoutingModule],
  imports: [BrowserModule, IonicModule.forRoot({ animated: true }), AppRoutingModule, LoaderModule],
  //on déclare en desous l'instance de nos services 
  //( donc on créer une instance par service, faire attention c'est la base du singleton !!! si tu connais pas le singleton alors vire de mon projet c'est pas pour les enfants ici!!!)
  providers: [CameraViewerService, SQLiteService, { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, MenuNaviService, TraductionService, UserService, WebsocketService, ModulesManagerService, ToolsService, ScanQr, Diagnostic, DocumentsService, FormBuilder, LoggerService/*,SplashScreen*/],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class AppModule {

}